import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { rotuloStatusNFeEntrada } from '@shared/helpers/nota-fiscal-entrada-status.helper';
import { AvisoAssociacaoPendenteDialogData, AvisoAssociacaoPendenteDialogResult } from './aviso-associacao-pendente-dialog.data';

/**
 * "Itens da nota ainda não foram associados" — nota da Gaveta com algum item ainda sem
 * produto associado. "Associar itens da NF-e" fecha com `{ associar: true }` e a Gaveta abre a
 * associação de itens da Central (origem Kanban/vínculo); Cancelar fecha sem resultado.
 * Textos e layout do bloco `avisoVinculoVals`/`avisoVincOpen` do protótipo.
 */
@Component({
  selector: 'app-aviso-associacao-pendente-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './aviso-associacao-pendente-dialog.component.html',
  styleUrl: './aviso-associacao-pendente-dialog.component.css',
})
export class AvisoAssociacaoPendenteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AvisoAssociacaoPendenteDialogComponent, AvisoAssociacaoPendenteDialogResult | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: AvisoAssociacaoPendenteDialogData,
  ) {}

  get numeroNota(): string {
    const numero = this.data.nota.numero ?? '—';
    return this.data.nota.serie ? `${numero}/${this.data.nota.serie}` : numero;
  }

  get statusLabel(): string {
    return rotuloStatusNFeEntrada(this.data.nota.idStatusNFeEntrada);
  }

  /** "2 itens do XML" no subtítulo; vazio quando a nota ainda não tem itens. */
  get itensLabel(): string {
    const n = this.data.nota.quantidadeItens ?? 0;
    if (!n) return '';
    return `${n} ${n === 1 ? 'item do XML' : 'itens do XML'}`;
  }

  /** "os 2 itens do XML" / "os itens do XML" no texto. */
  get itensTexto(): string {
    const n = this.data.nota.quantidadeItens ?? 0;
    return n ? `${n} ${n === 1 ? 'item do XML' : 'itens do XML'}` : 'itens do XML';
  }

  cancelar(): void {
    this.dialogRef.close();
  }

  associarItens(): void {
    this.dialogRef.close({ associar: true });
  }
}
